<template>
  <div class="tile information--how-to">
    <p class="content__heading">How To</p>
    <div class="accordian">
      <Fold v-for="item in getHowTos" :key="item.id" :item="item" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Fold from "./Fold";
export default {
  components: {
    Fold
  },
  computed: {
    ...mapGetters(["getHowTos"])
  }
};
</script>

<style scoped lang="scss">
</style>